import React from "react";
import "../HeroLeft.css";

const features = [
  {
    icon: "🛡️",
    title: "Devis clair et personnalisé",
    text: "Une estimation adaptée à votre bien et à vos besoins.",
  },
  {
    icon: "✅",
    title: "Réponse rapide",
    text: "Retour sous 24h ouvrées par email ou téléphone.",
  },
  {
    icon: "🗓️",
    title: "Planification simple",
    text: "Proposition de créneaux selon vos disponibilités.",
  },
  {
    icon: "🔁",
    title: "Accompagnement expert",
    text: "Un interlocuteur unique pour cadrer la demande.",
  },
];

export default function HeroLeft() {
  return (
    <section className="hero-left">
      <div className="hero-left__surface">
        <div className="hero-pill">Devis gratuit sous 24h</div>
        <h1 className="hero-title">Obtenez un devis pour votre projet immobilier</h1>
        <p className="hero-subtitle">Décrivez votre besoin en quelques clics. Réponse sous 24h ouvrées.</p>

        <div className="hero-features">
          {features.map((feature) => (
            <div className="hero-feature" key={feature.title}>
              <div className="hero-feature__icon" aria-hidden="true">{feature.icon}</div>
              <div className="hero-feature__content">
                <div className="hero-feature__title">{feature.title}</div>
                <p className="hero-feature__text">{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
